module.exports = __webpack_public_path__ + "img/hander.8b8bfacc.png";